import './MainExploreContainer.css';
import { IonRadio, IonRadioGroup, IonList, IonItem, IonLabel, IonButtons, IonContent, IonFooter, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonGrid, IonRow, IonCol, IonFabButton , IonButton, IonText} from '@ionic/react';
import { IonImg, } from '@ionic/react';
import {  IonItemSliding,  IonItemOptions, IonItemOption, IonIcon, IonReorder, IonReorderGroup } from '@ionic/react';

import { heart, trash, star, archive, ellipsisHorizontal, ellipsisVertical } from 'ionicons/icons';


interface ContainerProps {
  name: string;
}

const MainExploreContainer: React.FC<ContainerProps> = ({ name }) => {
  
       return(
                <IonPage>
                        <IonHeader>
                                <IonToolbar color = 'dyglot'>
                                        <IonButtons slot="end" >
                                                <IonMenuButton color = 'white'/>
                                        </IonButtons>
                                        <IonTitle color = 'white'>Open Dyglot</IonTitle>
                                </IonToolbar>

                        </IonHeader>
                
                        <IonContent fullscreen color='tertiary' >
                                <IonImg src='../assets/images/banner.png'/>
                                <IonGrid>
                                        <IonRow  class="cell-1" >
                                                <IonCol class="cell-1"  >
                                                </IonCol>
                                        </IonRow>



                                        <IonRow>
                                                <IonCol >
                                                        <IonText color='medium'>Classroom: </IonText>
                                                        <IonText >Korean</IonText>
                                                </IonCol>
                                                <IonCol>
                                                        <IonText color='medium'>Student: </IonText>
                                                        <IonText >Jean</IonText>
                                                </IonCol>
                                        </IonRow>

                                        <IonRow  class="cell-1" >
                                                <IonCol>
                                                        Cards selected: 906/6930
                                                </IonCol>
                                        </IonRow>
                                        <IonRow>
                                                <IonCol>
                                                </IonCol>
                                        </IonRow>

                                        <IonRow>
                                                <IonCol   size = '4.5'>
                                                        <IonText color='medium'>Practice Mode: </IonText>
                                                </IonCol>
                                                <IonCol >
                                                        <IonText color='medium'>Filter: </IonText>
                                                </IonCol>
                                        </IonRow>

                                        <IonRow>
                                                <IonCol  size = '4.5' class = 'ion-justify-content-around'>
                                                <IonRadioGroup class = 'ion-justify-content-around'>
                                                        <IonItem>
                                                        <IonLabel>Korean</IonLabel>
                                                        <IonRadio slot="start" value="1" />
                                                        </IonItem>

                                                        <IonItem>
                                                        <IonLabel>Hanja</IonLabel>
                                                        <IonRadio slot="start" value="2" />
                                                        </IonItem>

                                                        <IonItem>
                                                        <IonLabel>English</IonLabel>
                                                        <IonRadio slot="start" value="3" />
                                                        </IonItem>


                                                        <IonItem>
                                                        <IonLabel>Browse</IonLabel>
                                                        <IonRadio slot="start" value="4" />
                                                        </IonItem>

                                                        <IonItem>
                                                        <IonLabel>Auto</IonLabel>
                                                        <IonRadio slot="start" value="5" />
                                                        </IonItem>
                                                </IonRadioGroup>


                                                </IonCol>


                                                        <div style={{height: 400, overflow: 'auto'}}>

                                                <IonCol >

                                                        <IonList>

<IonReorderGroup disabled={false}>


{/* Sliding item with icon start options on end side */}
<IonItemSliding>
 
    <IonItem>
      <IonLabel>
        Sliding Item 1
      </IonLabel>
      <IonReorder slot="end" />
   </IonItem>
    <IonItemOptions>
      <IonItemOption color="primary">
        <IonIcon slot="start" ios={ellipsisHorizontal} md={ellipsisVertical}></IonIcon>
        More
      </IonItemOption>
      <IonItemOption color="secondary">
        <IonIcon slot="start" icon={archive} />
        Archive
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>
 

{/* Sliding item with icon start options on end side */}
  <IonItemSliding>
    <IonItem>
      <IonLabel>
        Sliding Item 2
      </IonLabel>
      <IonReorder slot="end" />
    </IonItem>
    <IonItemOptions>
      <IonItemOption color="primary">
        <IonIcon slot="start" ios={ellipsisHorizontal} md={ellipsisVertical}></IonIcon>
        More
      </IonItemOption>
      <IonItemOption color="secondary">
        <IonIcon slot="start" icon={archive} />
        Archive
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>


{/* Sliding item with icon start options on end side */}
  <IonItemSliding>
    <IonItem>
      <IonLabel>
        Sliding Item 3
      </IonLabel>
     <IonReorder slot="end" />
    </IonItem>
    <IonItemOptions>
      <IonItemOption color="primary">
        <IonIcon slot="start" ios={ellipsisHorizontal} md={ellipsisVertical}></IonIcon>
        More
      </IonItemOption>
      <IonItemOption color="secondary">
        <IonIcon slot="start" icon={archive} />
        Archive
      </IonItemOption>
    </IonItemOptions>
  </IonItemSliding>

                                                                <IonItem>
                                                                        <IonLabel>Pokémon Yellow</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Mega Man X</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>The Legend of Zelda</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pac-Man</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Super Mario World</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pokémon Yellow</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Mega Man X</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>The Legend of Zelda</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pac-Man</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Super Mario World</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pokémon Yellow</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Mega Man X</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>The Legend of Zelda</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pac-Man</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Super Mario World</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pokémon Yellow</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Mega Man X</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>The Legend of Zelda</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Pac-Man</IonLabel>
                                                                </IonItem>
                                                                <IonItem>
                                                                        <IonLabel>Super Mario World</IonLabel>
                                                                </IonItem>


 </IonReorderGroup>                                                               
                                                        </IonList>
                                                </IonCol>

</div>

                                        </IonRow>

                                </IonGrid>
                        </IonContent>
                
                        <IonFooter>
                                <IonToolbar color='tertiary' >
                                        <IonButton  slot='end'> New Filter
                                        </IonButton>
                                        <IonFabButton color="light" slot='end' >Practice</IonFabButton>
                                </IonToolbar>
                        </IonFooter>
                
                </IonPage>
        );};

export default MainExploreContainer;
